module.exports = __webpack_public_path__ + "img/laboratory.8f6cf990.png";